import React, { useState, useEffect } from 'react'
import { LinearProgress, Box } from '@material-ui/core'
import { useGlobalContext } from '../../state'
import { getIndicatorMenu } from '../../utils/apiHelper'
import { sectionComponents } from '../../utils/configQueries'
import { CustomAccordion } from './CustomAccordion'
import { Option } from './Option'
import MenuIndicator from './MenuIndicator'

import { useStyles } from './styles'

export const SubmenuItems = ({ items }) => {
  const classes = useStyles()
  const isFirstChildren = items.every(({ type }) => type === 'firstChildren')
  const isIndicatorFirstChildren = items.every(
    ({ type }) => type === 'indicatorFirstChildren'
  )
  return (
    <Box
      className={
        isFirstChildren
          ? classes.containerPDIAccordion
          : isIndicatorFirstChildren
          ? classes.containerAccordion
          : classes.default
      }
    >
      {items.map(
        (
          {
            children,
            id,
            area_id: areaId,
            name,
            color,
            submenu,
            type,
            render,
            icon,
            arrowIcon,
            query,
            queryRedmine,
            style
          },
          index
        ) => (
          <Box key={index} style={{ width: '99.8%' }}>
            {render && render === 'Option' ? (
              <Option
                key="Option"
                id={id || index}
                style={style}
                type={type}
                name={name}
                color={color}
                icon={icon}
                query={query}
                queryRedmine={queryRedmine}
                submenu={submenu}
                arrowIcon={arrowIcon}
              />
            ) : (
              sectionComponents.get(render)
            )}
            {!render && (children || submenu?.length > 0) && (
              <CustomAccordion
                key={index}
                id={id || index}
                areaId={areaId}
                arrowIcon={arrowIcon}
                icon={icon}
                name={name}
                submenu={submenu}
                type={type || 'indicatorItem'}
              >
                {children}
              </CustomAccordion>
            )}
          </Box>
        )
      )}
    </Box>
  )
}
export const Submenu = ({ items, indicator }) => {
  const {
    state: { language }
  } = useGlobalContext()

  const [tree, setTree] = useState([])
  useEffect(() => {
    if (indicator) {
      let isSubscribed = true
      setTree([])
      getIndicatorMenu().then((menu) => {
        return isSubscribed && setTree(menu)
      })
      return () => (isSubscribed = false)
    } else if (items) {
      setTree(items)
    }
  }, [items, language, indicator])

  return (
    <Box>
      {!tree.length && indicator ? (
        <LinearProgress />
      ) : indicator ? (
        <MenuIndicator items={tree} />
      ) : (
        <SubmenuItems items={tree} />
      )}
    </Box>
  )
}
